import { DirectoryGroupingConsts, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import DirectoryGroupingApi from 'client/api/v2/DirectoryGroupingApi';
import ModelMixin from 'client/store/modules/models/mixins/ModelMixin';
import SystemGroupApi from 'client/api/v2/SystemGroupApi';
import Vue from 'vue';
import createModel from 'client/store/modules/models/createModel';

const { groupTypes, memberTypes } = DirectoryGroupingConsts;

export const getDefaultItem = () => ({
  id: '',
  name: '',
  passwordLessSudoEnabled: false,
  sudoEnabled: false,
  type: ItemTypeConsts.systemGroup,
});

const model = createModel(getDefaultItem, 'id', SystemGroupApi);

export default {
  namespaced: true,

  state: {
    ...model.state,
    membership: 0,
  },

  actions: {
    ...model.actions,

    bindSudoStatus(context) {
      const { id } = context.getters;
      const targetsToUpdate = context.getters.getSudoersToUpdate;

      const payload = {
        parentType: groupTypes.systemGroup,
        parentId: id,
        targetType: memberTypes.system,
        targetsToUpdate,
      };

      return context.dispatch(
        'DirectoryGroupingModule/bindAttributes',
        payload,
        { root: true },
      );
    },

    bindSystemGroupToSystems(context) {
      return context.dispatch('bindAssociations', {
        parentType: groupTypes.systemGroup,
        targetType: memberTypes.system,
      });
    },

    bindSystemGroupToUserGroups(context) {
      return context.dispatch('bindAssociations', {
        parentType: groupTypes.systemGroup,
        targetType: groupTypes.userGroup,
      });
    },

    bindSystemGroupToPolicies(context) {
      return context.dispatch('bindAssociations', {
        parentType: groupTypes.systemGroup,
        targetType: ItemTypeConsts.policy,
      });
    },

    bindSystemGroupToConfigurationGroups(context) {
      return context.dispatch('bindAssociations', {
        parentType: groupTypes.systemGroup,
        targetType: ItemTypeConsts.configurationGroup,
      });
    },

    async getSystemGroupAssociations(context, { parentId, targetType }) {
      const parentType = groupTypes.systemGroup;
      const associations = await DirectoryGroupingApi
        .getAssociations(parentType, parentId, targetType);

      return associations;
    },

    fetchMembership({ commit }, systemGroupId) {
      return SystemGroupApi.getMembership(systemGroupId)
        .then((response) => {
          commit('UPDATE_MEMBERSHIP', response.headers['x-total-count']);
        });
    },
  },

  getters: {
    ...model.getters,
    ...ModelMixin.getters,

    displayName(state) {
      return state.item.name;
    },

    getSudoersToUpdate(state, getters, rootState, rootGetters) {
      const module = StoreModuleMap[ItemTypeConsts.userGroup];
      return rootGetters[`${module}/getSudoersToUpdate`];
    },

    haveAssociationsChanged(state, getters) {
      const associationTypes = [
        memberTypes.system,
        groupTypes.userGroup,
        ItemTypeConsts.policy,
        ItemTypeConsts.configurationGroup,
      ];

      const sudoersToUpdate = getters.getSudoersToUpdate;

      if (sudoersToUpdate && Object.keys(sudoersToUpdate).length) return true;

      return model.getters.haveAssociationsChanged(state, getters)(associationTypes);
    },

    getUserGroupAssociationCounts(state, getters) {
      const userGroupsToBind = getters.getTargetsToBind(groupTypes.userGroup);
      const userGroupsToUnbind = getters.getTargetsToUnbind(groupTypes.userGroup);
      return { bind: userGroupsToBind.length, unbind: userGroupsToUnbind.length };
    },

    membershipCount(state) {
      return state.membership;
    },
  },

  mutations: {
    ...model.mutations,

    UPDATE_MEMBERSHIP(state, membership) {
      Vue.set(state, 'membership', membership);
    },
  },
};
